var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* istanbul ignore next */
const delayRefresh = () => __awaiter(void 0, void 0, void 0, function* () {
    const TIME_REFERENCE = 1643236071000;
    const delay = Math.min(((Date.now() - TIME_REFERENCE) % 3) * 1000 + 100, 3000);
    return new Promise(function (fulfill, reject) {
        setTimeout(() => {
            fulfill();
        }, delay);
    });
});
const BlockchainTransactionUtils = {
    delayRefresh,
};
export default BlockchainTransactionUtils;
